export const USER_NAME_MIN_LENGTH = 3;

export const USER_NAME_MAX_LENGTH = 20;

export const USER_NOTE_MAX_LENGTH = 255;

export const USER_PASSWORD_MIN_LENGTH = 8;
